import { Dispatch, SetStateAction } from "react";
import { t } from "i18next";
import { MRT_Row, MRT_RowSelectionState } from "material-react-table";
import { BookableEquipmentTableRow } from "./BookableEquipmentRow.types";
import {
  BookingServiceBookableEquipData,
  BookingServiceEditedData,
  OrderableBookableEquipmentEditedData,
  ServiceOrderDto
} from "../Domain/BookingServicePrompt.types";
import { BookingInputs } from "../../../../../Domain/Types/BookingInputs.type";
import { isServiceItemOrderable } from "../functions/filterByServiceTime.function";
import * as _ from "lodash";
import { getLowestLeadTimeEntry } from "../functions/getLowestLeadTimeEntry.function";

export const updQuantityOfBookableEquipments = (
  row: MRT_Row<BookableEquipmentTableRow>,
  quantity: number,
  editedData: BookableEquipmentTableRow[],
  setEditedData: (data: BookableEquipmentTableRow[]) => void,
  serviceOrder: ServiceOrderDto,
  setServiceOrder: Dispatch<SetStateAction<ServiceOrderDto>>
) => {
  if (!editedData?.length) return;

  const index = editedData.findIndex(d => d.id === row.original.id);
  /**
   * const orderIndex = serviceOrder.bookableEquipments.findIndex(eq => eq.id === row.original.id);
   */
  if (index >= 0) {
    editedData[index].qty = quantity;
    setEditedData(editedData);
    setServiceOrder(serviceOrder);
  }
  /**
   * if (orderIndex >= 0) serviceOrder.bookableEquipments[orderIndex].qty = quantity;
   */
};

export const handleInitialBookablEqup = (
  serviceOrder: ServiceOrderDto,
  bookableEquipmentData: OrderableBookableEquipmentEditedData[],
  setRowSelection: (value: SetStateAction<MRT_RowSelectionState>) => void,
  isMandatory: boolean
) => {
  const orderedEquipments = _.uniqBy(
    serviceOrder.bookableEquipments.flatMap(ent => ent ?? []),
    prop => prop.id
  ).map(p => p.id);

  if (!orderedEquipments.length) {
    if (isMandatory) {
      const lowest = getLowestLeadTimeEntry(bookableEquipmentData);
      setRowSelection(prev => ({ ...prev, [`${lowest.id}`]: true }));
    } else return;
  }

  for (const prop of orderedEquipments) {
    setRowSelection(prev => ({ ...prev, [`${prop}`]: true }));
  }
};

export function initiateBookableEquipmentData({
  bookingInputs,
  maxSetupTime,
  assignedBookableEquipItems,
  conferenceService,
  isServiceAdminBypass = false,
  setEditedService,
  setOrderedService
}: {
  bookingInputs: BookingInputs;
  maxSetupTime: number;
  assignedBookableEquipItems: BookingServiceBookableEquipData[];
  conferenceService: ServiceOrderDto | undefined;
  isServiceAdminBypass?: boolean;
  setEditedService: (value: SetStateAction<BookingServiceEditedData>) => void;
  setOrderedService: (value: SetStateAction<ServiceOrderDto>) => void;
}) {
  setEditedService(prev => ({
    ...prev,
    bookableEquipmentData: mapBookEquipmentTableData(
      bookingInputs,
      assignedBookableEquipItems,
      maxSetupTime,
      isServiceAdminBypass
    )
  }));

  if (conferenceService?.bookableEquipments && conferenceService?.bookableEquipments.length > 0) {
    setOrderedService(prev => ({
      ...prev,
      bookableEquipments: conferenceService?.bookableEquipments
    }));
  }
}

/**
 * mapping bookable equipment table data filter by service time and include/exclude based on the orderable boolean
 */
export function mapBookEquipmentTableData(
  bookingInputs: BookingInputs,
  assignedEquipItems: any[],
  maxSetupTime: number,
  isServiceAdminBypass = false
) {
  return assignedEquipItems
    .filter(equip => {
      const setUpTime = equip.setUpTime ?? 15;
      const bookingLeadTime = equip.bookingLeadTime ?? 1;

      return isServiceItemOrderable({
        bookingFrom: bookingInputs.bookingFrom,
        bookingStart: bookingInputs.bookingStart,
        setUpTime,
        bookingLeadTime,
        maxSetupTime,
        isServiceAdminBypass
      });
    })
    .map(equip => ({
      ...equip,
      category: equip.category?.name ?? t("No Category"),
      selectingIsMandatory: equip.selectingIsMandatory ?? false,
      setUpTime: equip.setUpTime ?? 15,
      bookingLeadTime: equip.bookingLeadTime ?? 1,
      qty: 0,
      orderable: true
    }));
}
